<template>
  <section class="flex max-w-full w-screen min-h-screen">
    <portal-target name="dropdown" slim class="teste" />
    <div class="container_content w-full min-h-screen p-10">
      <div class="header w-full h-14 flex justify-between items-center mb-10 flex-wrap">
        <div class="flex items-center justify-center gap-7">
          <div class="cursor-pointer">
            <inertia-link href="/">
              <img src="/goback.svg" alt="Voltar" />
            </inertia-link>
          </div>
          <div class="h-10 w-52">
            <inertia-link href="/">
              <img :src="'/logo-slim-dark.png'" alt="Logo" class="w-full h-full" />
            </inertia-link>
          </div>
        </div>
        <div class="flex gap-3">
          <p>
            <span
              >Olá,
              <strong class="text-indigo">{{ $page.props.auth.user.first_name }}</strong></span
            >
            <span class="hidden md:inline"
              ><strong class="text-indigo">{{ $page.props.auth.user.last_name }}</strong></span
            >
          </p>
          <inertia-link :href="route('users.edit', $page.props.auth.user.id)">
            <icon class="w-5 h-5 ml-3" name="user" style="fill: #00a39a" />
          </inertia-link>

          <inertia-link :href="route('logout')" method="delete">
            <icon class="w-5 h-5 ml-3" name="exit" style="fill: #00a39a" />
          </inertia-link>
        </div>
      </div>
      <div class="">
        <flash-messages />
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    MainMenu,
  },
}
</script>

<style scoped>
.container_navigation {
  min-width: 300px;
  max-width: 300px;
  height: 100vh;
}

.container_content {
  width: 100%;
  max-width: 100%;
}

@media screen and (max-width: 1000px) {
  section {
    display: flex;
    flex-direction: column;
  }

  .container_navigation {
    position: static;
    width: 100vw;
    max-width: 100%;
    min-height: 90px;
    height: 90px;
    background-color: #1e293b;
  }

  .container_content {
    padding-left: 20px;
    height: 100%;
  }
}
</style>
